import { useEffect, useCallback, useState } from 'react';
import { KEYBOARD_KEYS } from '@CommonConstants';

const useContextMenu = (isClosedAnywhereClicked = true, contextMenuRef = null) => {
  const [isContextMenuVisible, setContextMenuVisible] = useState(false);

  const handleShowContextMenuClick = useCallback(
    event => {
      event.preventDefault();

      setContextMenuVisible(true);
    },
    [isContextMenuVisible],
  );

  const handleCloseContextMenuClick = useCallback(() => {
    setContextMenuVisible(false);
  }, [isContextMenuVisible]);

  const handleCloseContextMenuEnterPress = useCallback(
    event => {
      if (event) {
        const { key } = event;

        if (key === KEYBOARD_KEYS.ENTER) {
          setContextMenuVisible(false);
        }
      }
    },
    [isContextMenuVisible],
  );

  const handleCloseContextMenuOutsideClick = useCallback(
    event => {
      const { target } = event;

      if (contextMenuRef === null || contextMenuRef.current === null) {
        return;
      }

      if (!contextMenuRef.current.contains(target)) {
        setContextMenuVisible(false);
      }
    },
    [contextMenuRef, isContextMenuVisible],
  );

  useEffect(() => {
    if (isContextMenuVisible && isClosedAnywhereClicked) {
      document.addEventListener('click', handleCloseContextMenuClick);
      document.addEventListener('keyup', handleCloseContextMenuEnterPress);
      document.addEventListener('contextMenu', handleShowContextMenuClick);
    }

    if (isContextMenuVisible && !isClosedAnywhereClicked) {
      document.addEventListener('mousedown', handleCloseContextMenuOutsideClick);
    }

    return () => {
      if (isContextMenuVisible && isClosedAnywhereClicked) {
        document.removeEventListener('click', handleCloseContextMenuClick);
        document.removeEventListener('keyup', handleCloseContextMenuEnterPress);
        document.removeEventListener('contextMenu', handleShowContextMenuClick);
      }

      if (isContextMenuVisible && !isClosedAnywhereClicked) {
        document.removeEventListener('mousedown', handleCloseContextMenuOutsideClick);
      }
    };
  }, [isContextMenuVisible, isClosedAnywhereClicked]);

  return { isContextMenuVisible, handleShowContextMenuClick, handleCloseContextMenuClick };
};

export default useContextMenu;
